import { Button, CircularProgress } from "@material-ui/core";
import { useCallback } from "react";
import { useAmenities } from "../../../graphql/hooks";
// import { useLoggedUserInfo } from "../../../hooks";
import { ReservationFilterValue } from "../../pages/reservations/reservation_filters";

export type GenerateAmenitiesReportProps = {
  amenityReservationsFilters: ReservationFilterValue;
};
export function GenerateAmenitiesReport(props: GenerateAmenitiesReportProps) {
  const { amenityReservationsFilters } = props;

  const {
    createAmenityReservationsReport,
    createAmenityReservationsReportLoading,
  } = useAmenities({
    onAmenityReservationsReportCreated(attachment) {
      window.open(attachment.url);
    },
  });

  const triggerCreateAmenityReservationsReport = useCallback(() => {
    createAmenityReservationsReport(amenityReservationsFilters);
  }, [createAmenityReservationsReport, amenityReservationsFilters]);

  return (
    <Button
      disabled={createAmenityReservationsReportLoading}
      onClick={triggerCreateAmenityReservationsReport}
    >
      {!createAmenityReservationsReportLoading && "Scarica report prenotazioni"}
      {createAmenityReservationsReportLoading && <CircularProgress />}
    </Button>
  );
}
